export default function validateCreateSequence(values) {
    let errors = {}

    if (!values.name) {
        errors.name = "You must enter a name"
    }

    if (values.name.length > 50) {
        errors.name = "Name can't be longer than 50 characters"
    }

    if (values.description.length > 250) {
        errors.description = "Description can't be longer than 250 characters"
    }

    return errors
}
